<template>
  <div class="flex flex-col items-center content-center justify-center p-5">
    <div class="w-full max-w-3xl">
      <ExternalUnauthorized />
    </div>
  </div>
</template>

<script>
import ExternalUnauthorized from '@/components/ExternalUnauthorized'

export default {
  name: 'ExternalUnauthorizedView',

  components: {
    ExternalUnauthorized
  }
}
</script>
